<div class="flex-col">
    <div class="mb-2">{{app.t("entity.Project.other.roleAssignments")}}</div>
    <sm-table #tableComponent class="flex-item-fill height300" columnWidthMode="content" [data]="tableRoles"></sm-table>
    <div class="mt-3 mb-2">{{app.t("entity.Project.other.contactPersonAssignments")}}</div>
    <sm-table #tableComponent class="flex-item-fill height300" columnWidthMode="content" [data]="tableContactPersons"></sm-table>
</div>